import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { inject, NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthModule } from 'ngx-auth';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ToastrModule } from 'ngx-toastr';

import { BaseTranslatableModule } from 'app/core/internationalization/translatable-module';
import { TranslationLoaderHelper } from 'app/core/internationalization/translation-loader-helper';
import { SharedModule } from 'app/shared/shared.module';
import { AppRoutingModule } from '../app-routing.module';

import { EnvironmentService } from './app-constants/environment.service';
import {
  AuthenticationDataService,
  AuthenticationService,
  AuthGuard,
  PermissionsService,
  PublicRedirectGuard
} from './authentication';
import { NgxZendeskWebwidgetModule } from './chat/zendesk-webwidget/zendesk-webwidget.module';
import { AnswerExplanationComponent } from './enhanced-report/answer-explanation/answer-explanation.component';
import { QuestionRationaleComponent } from './enhanced-report/question-rationale/question-rationale.component';
import { UrlService } from './http/url.service';
import { EmptyLayoutComponent } from './layouts/empty-layout/empty-layout.component';
import { Logger } from './logger/services/logger.service';
import { ConfirmDialogComponent } from './modals/confirm-dialog/confirm-dialog.component';
import { GuestAccountRequiredGuardComponent } from './modals/guest-account-required-guard/guest-account-required-guard.component';
import { InputDialogComponent } from './modals/input-dialog/input-dialog.component';
import { throwIfAlreadyLoaded } from './module-import-guard';
import { ExternalLinkGuard, RouterService } from './navigation';
import { SessionExpiredModalComponent } from './session-refresh/session-expired-modal/session-expired-modal.component';
import { GAMESHOW_REPOSITORY } from './storage/gameshow-repository.interface';
import { KhGameShowStorageService } from './storage/kh-game-show-storage.service';

@NgModule({
  declarations: [
    EmptyLayoutComponent,
    ConfirmDialogComponent,
    InputDialogComponent,
    GuestAccountRequiredGuardComponent,
    AnswerExplanationComponent,
    QuestionRationaleComponent
  ],
  imports: [
    AuthModule,
    AppRoutingModule,
    CommonModule,
    FontAwesomeModule,
    SharedModule,
    SessionExpiredModalComponent,
    ToastrModule,
    ModalModule.forRoot(),
    NgxZendeskWebwidgetModule,
    CarouselModule
  ],
  providers: [
    AuthenticationService,
    AuthenticationDataService,
    AuthGuard,
    ExternalLinkGuard,
    Logger,
    RouterService,
    UrlService,
    PublicRedirectGuard,
    PermissionsService,
    BsModalService,
    EnvironmentService,
    { provide: GAMESHOW_REPOSITORY, useClass: KhGameShowStorageService },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class CoreModule extends BaseTranslatableModule {
  public constructor() {
    const helper = inject(TranslationLoaderHelper);
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    super(helper, 'core');
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
